import { Hotel, Dice5, Landmark, Store } from "lucide-react";

const ITEMS = [
  [Hotel, "Hotels", "~1,350", "Guests' and staff AI on the Wi-Fi, plus assistants reaching your booking engine and PMS."],
  [Dice5, "Casino resorts", "~8,400", "AI across guest and employee Wi-Fi, marketing and the cage, plus agents reaching loyalty and booking systems."],
  [Landmark, "Banks & credit unions", "~580", "See which AI tools tellers, lenders and back office use, and which agents reach online banking."],
  [Store, "Vendors & small businesses", "~180", "Know which AI tools your office relies on and who is reaching your systems."],
];

export const Industries = () => (
  <section id="industries" className="border-y border-[#222D3D] bg-[#0F141C] scroll-mt-16" data-testid="landing-industries">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <p className="font-mono text-xs text-emerald-400 tracking-[0.3em] uppercase">Who it's for</p>
      <h2 className="text-2xl sm:text-3xl font-semibold text-slate-50 mt-3 max-w-2xl">Built for businesses AI agents already talk about.</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
        {ITEMS.map(([Icon, title, daily, body]) => (
          <div key={title} className="rounded-md border border-[#222D3D] bg-[#141A24] p-6">
            <Icon className="h-6 w-6 text-slate-300" />
            <h3 className="text-base font-semibold text-slate-100 mt-5">{title}</h3>
            <p className="font-mono text-2xl font-bold text-emerald-400 mt-3">{daily}</p>
            <p className="text-[11px] text-slate-500">estimated AI agent arrivals a day</p>
            <p className="text-sm text-slate-400 mt-4 leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-600 mt-6">Estimates for a typical property; try each one in the built-in simulator.</p>
    </div>
  </section>
);
